import { Image, Container, Row, Col } from 'react-bootstrap';
import Sidebar from './AnimatedList';
import "./Services.css";

function Import() {
    return (
         <>
            <Image className="fade-in responsive-img" src="https://windward.ai/wp-content/uploads/2025/05/shipping-logistics-featured-scaled.jpg" height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col md={8}>
                        <h1 className='text-center my-2 text-decoration-underline'><strong>Imports</strong></h1>
                        <p style={{ fontSize: '20px' }} className='justify-text'>With years of industry experience, DELTRANS GLOBAL provides comprehensive import solutions tailored to meet international trade requirements and evolving market demands. We manage the complete import process in accordance with global standards and regulatory guidelines, ensuring full compliance at every stage. Our team handles documentation, customs clearance, cargo coordination, and final delivery with precision and efficiency. Through strong global partnerships and structured operational systems, we ensure timely, secure, and cost-effective import services for a wide range of commodities.</p>
                    </Col>
                    <Col md={4}>
                    <Sidebar/>
                    </Col>
                </Row>
            </Container>
           
        </>
    )
}

export default Import